import React from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as ChatIcon } from 'src/assets/icons/chat.svg';
import { ReactComponent as RequestIcon } from 'src/assets/icons/request.svg';
import { ReactComponent as CheckIcon } from 'src/assets/icons/check-soft.svg';

import * as Styled from './styles';

const ChatCircle = () => (
  <Styled.Circle>
    <ChatIcon />
  </Styled.Circle>
);

const RequestCircle = () => (
  <Styled.Circle>
    <RequestIcon />
  </Styled.Circle>
);

const controls = [
  {
    id: 'request',
    title: 'Standard Chat',
    description: 'Power chat support without setting any time expectations with customers.',
    Icon: () => (
      <Styled.Figure>
        <RequestCircle />
      </Styled.Figure>
    )
  },
  {
    id: 'live',
    title: 'Chat with SLAs',
    description:
      'Let customers know when to expect responses to new threads. Swarm Mode is enabled for Inbox users.',
    Icon: () => (
      <Styled.Figure>
        <ChatCircle />
      </Styled.Figure>
    )
  }
];

const SupportTypeSection = ({ value, onChange }) => (
  <Styled.Wrapper>
    {controls.map(({ id, title, description, Icon }) => (
      <Styled.Label key={id}>
        <Styled.Input
          className="visually-hidden"
          type="radio"
          name="supportType"
          id={id}
          checked={value === id}
          onChange={onChange}
        />
        <Icon />
        <Styled.Title>{title}</Styled.Title>
        <Styled.Description>{description}</Styled.Description>
        <Styled.Check>
          <CheckIcon />
        </Styled.Check>
      </Styled.Label>
    ))}
  </Styled.Wrapper>
);

SupportTypeSection.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired
};

SupportTypeSection.defaultProps = {
  value: 'live'
};

export default SupportTypeSection;
